// extracted by mini-css-extract-plugin
export default {"mailing_list_container":"MailingListEmails_mailing_list_container__6SZeR","noMailingList":"MailingListEmails_noMailingList__CN+IN"};